import { infoColor } from '../global';

const style = (theme) => ({
    brand: {
        marginTop: '10vh',
        marginBottom: '5vh',
    },
    errorCode: {
        fontSize: '150px',
        marginBottom: '-30px',
    },
});

export default style;
